<template>
  <b-modal
    centered
    hide-footer
    footer-class="border-top-none"
    header-class="border-bottom-none"
    id="xoa-vai-tro-group"
    size="md"
    :title="'Bạn có chắc chắn xóa vai trò?'"
  >
    <div class="d-flex justify-content-end">
      <base-button button="Xóa" @click="xoaVaiTro()" class="btn btn-red ml-2">
        ĐỒNG Ý
      </base-button>
      <base-button button="Hủy" @click="hideModal()" class="btn btn-yellow">
        {{ BO_QUA_BUTTON_LABEL }}
      </base-button>
    </div>
  </b-modal>
</template>
<script>
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";

export default {
  name: "XoaVaiTroModal",
  props: {
    id: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | null,
      required: false,
    },
  },
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      ROUTE_NAME: ROUTE_NAME,
      emailSelected: 1,
      modalTitle: "",
      internalForm: {},
    };
  },
  watch: {
    form: {
      handler() {
        this.internalForm = this.form;
      },
      immediate: true,
    },
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("xoa-vai-tro-group");
    },
    xoaVaiTro() {
      this.$emit("xoaVaiTro");
    },
  },
};
</script>
<style lang="scss" >
#xoa-vai-tro-group .modal-header {
  background: white;
  h5 {
    color: black;
  }

  .close {
    display: none;
  }
}
</style>